import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/crm/customer-tier`;

export interface CustomerTierSummaryItem {
  customerTierId: string;
  customerCompanyId: number;
  customerNo: string;
  customerName: string;
  customerProvince: string;
  customerZone: string;
  currentTierName: string | null;
  currentTierColor: string | null;
  earnedTierName: string | null;
  earnedTierColor: string | null;
  isPendingReview: boolean;
  accruedTotal: number;
  accruedAmount: number;
  accruedQuantity: number;
  isUpdateNav: boolean;
  tierChangedAt: string | null;
  historyCount: number;
  updatedAt: string;
}

const getCustomerTierOverview = async (params: { 
  company: string
  tierLevelId? : string
  customerZone? : string
  search?: string
  status?: string
  isUpdateNav? : boolean
 }) => {
  return await httpClient
    .get(`${baseUrl}/get-customer-tier-overview`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getCustomerTierDetail = async (customerCompanyId : number) => {
  return await httpClient
    .get(`${baseUrl}/get-customer-tier-detail/${customerCompanyId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getCustomerTierSummary = async (
  params: { 
    company: string 
    tierLevelId? : string
    customerZone? : string
    search?: string
    status?: string
    isUpdateNav? : boolean
    sortBy : string
    sortOrder : string
    page: number
    take: number
  }
) => {
  return await httpClient
    .get(`${baseUrl}/get-customer-tier-summary`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};


const exportCustomerTierExcel = async (
  params: { 
    company: string 
    tierLevelId? : string
    customerZone? : string
    search?: string
    status?: string
    isUpdatedNav? : boolean
    sortBy? : string
    sortOrder? : string
    tierProgramId?: string
  }
) => {
  return await httpClient
    .get(`${baseUrl}/export-customer-tier-excel`, { params, responseType: "arraybuffer" })
    .then((res: AxiosResponse<ArrayBuffer>) => res)
    .catch((err) => {
      console.log(err);
      return undefined;
    });
};

const exportTierAuditLogExcel = async (
  params: { 
    company: string 
    customerZone? : string
    search?: string
    activity?: string[]
    year?: number
  }
) => {
  return await httpClient
    .get(`${baseUrl}/export-tier-audit-log-excel`, { params, responseType: "arraybuffer" })
    .then((res: AxiosResponse<ArrayBuffer>) => res)
    .catch((err) => {
      console.log(err);
      return undefined;
    });
};
// Mirrors getTierAuditLog in sellcoda-back-sellcoda-crm (customer-tier.service.ts).
// Shop fields are null on program-level rows.
export interface TierAuditLogItem {
  tierAuditLogId: string;
  createdAt: string;
  activity: string;
  company: string | null;
  tierProgramId: string | null;
  programYear: number | null;
  customerCompanyId: number | null;
  customerNo: string | null;
  customerName: string | null;
  customerZone: string | null;
  customerProvince: string | null;
  // Raw strings; meaning depends on activity (tier name, "true"/"false", or JSON for UPDATE_PROGRAM).
  valueBefore: string | null;
  valueAfter: string | null;
  accruedTotal: number | null;
  accruedQuantity: number | null;
  accruedAmount: number | null;
  remark: string | null;
  updatedBy: string | null;
}

const getTierAuditLog = async (params : {
  company: string
  search?: string
  customerZone?: string
  customerCompanyId? : number
  year? : number
  activity? : string[]
  page: number
  take: number
}) => {
  return await httpClient
    .get(`${baseUrl}/get-tier-audit-log`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const updateNavStatus = async (customerTierId: string, isUpdateNav: boolean, updatedBy: string) => {
  return await httpClient
    .post(`${baseUrl}/update-nav-status`, {
      customerTierId,
      isUpdateNav,
      updatedBy,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getPendingNavBadge = async(company : string) => {
  return await httpClient
    .get(`${baseUrl}/get-pending-nav-badge?company=${company}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
}
  

export { getCustomerTierOverview, getCustomerTierSummary, getCustomerTierDetail, updateNavStatus, getTierAuditLog, exportCustomerTierExcel, exportTierAuditLogExcel, getPendingNavBadge };